import ExamsRoleByStudentDataStore from '../datastores/ExamsRoleByStudentDataStore';
import ExamsRoleByStudentRepository from '@/domain/repositories/ExamsRoleByStudentRepository';
import ExamsRoleByStudentDataStoreFactory from '../factories/ExamsRoleByStudentDataStoreFactory';

export default class ExamsRoleByStudentDataRepository
  implements ExamsRoleByStudentRepository
{
  getExamsRoleByStudent(career: string, period: string) {
    const examsRoleDataStore: ExamsRoleByStudentDataStore =
      ExamsRoleByStudentDataStoreFactory.create();
    const examsRole = examsRoleDataStore.getExamsRoleByStudent(career, period);
    return examsRole;
  }
}
